module.exports = __webpack_public_path__ + "static/media/save_changes_orange_icon.ee76a5a7.svg";